import React, { useEffect, useState } from "react";
import "./DocUpload.css";
import {
  deleteSaveBankData,
  getBankData,
  saveBankData,
  getUploadFile,
  removeFile,
  getInstantBankData,
  deleteInstantBankData,
} from "../../Actions/BankVerificationAction";
import ImagePopup from "../ImagePopup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import RightArrowIcon from "../../assets/img/arrow-right-icon.png";
import { FileUploader } from "react-drag-drop-files";
import {
  validateAlphabetsAndNumeric,
  validateAlphabetsAndSpace,
  containsOnlyNumbers,
  validateAlphabetsAndNumericWithSpace,
} from "../../Helper/common";
import ClientHeader from "../Partials/ClientHeader";
import ClientSideBar from "../Partials/ClientSideBar";
import Header from "../Header";
import Sidebar from "../Sidebar";
import NotificationPanels from "../NotificationPanels";
import CandidateTab from "../CandidateTab";
import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import Bin from "../../assets/img/delete_Icon.png";
import UploadedDoc from "../../assets/img/uploaded-document.png";

const BankVerification = () => {
  const [fileName1, setFileName1] = useState("");
  const [bankDetail, setBankDetail] = useState();
  const [editBankDetail, setEditBankDetail] = useState();
  const [fileError, setFileError] = useState(false);
  const [url, setUrl] = useState();
  const [disableContinue, setDisableContinue] = useState(false);
  const [errorData, setErrorData] = useState({});
  const storeData = useSelector((state) => state.bankData);
  const storeData2 = useSelector((state) => state.instantBankData);
  const storeData1 = useSelector((state) => state.saveBankData1);
  const [showImageModal, setShowImageModal] = useState(false);
  const [image, setImage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bankData, loading: getDataLoading, error } = storeData;
  const { saveBankValue, loading: getDataLoad, err } = storeData1;
  const { instantBank, loading: getDataLoadin, er } = storeData2;
  console.log("inst", instantBank);
  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;
  const [isDivVisible, setIsDivVisible] = useState(false);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    const fetchData = async () => {
      let formData = {};
      formData.group = 20;
      const currentUrl = window.location.href;
      const [partA, partB] = currentUrl.split("/check-detail/");
      const [reference, route] = partB.split("/");
      formData.referenceNo = reference;
      dispatch(getBankData(formData));
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (typeof bankData.data !== "undefined" && bankData.data !== null) {
      console.log(bankData.data.data.showProfilePreview);
      setBankDetail(bankData.data?.data?.checksDetails[0].fields);
    }

    if (bankData.data?.data?.checksDetails[0]?.uploaded_documents) {
      setFileName1(
        bankData.data?.data?.checksDetails[0].uploaded_documents[0].file_name
      );
    }
  }, [bankData, storeData]);

  useEffect(() => {
    if (typeof instantBank !== "undefined" && instantBank !== null) {
      if (instantBank?.msg?.description == "Success`") {
        setDisableContinue(false);
      }
      if (instantBank?.msg?.description == "Failed") {
        setIsDivVisible(false);
        toast.dismiss();

        toast.error("Wrong details entered", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (instantBank?.msg?.name) {
        setIsDivVisible(true);
      }
    }
  }, [instantBank, storeData2]);

  useEffect(() => {
    if (typeof bankData.data !== "undefined" && bankData.data !== null) {
      if (bankData.data.data.checksDetails[0].uploaded_documents) {
        for (let i in bankData.data?.data?.checksDetails[0]
          .uploaded_documents) {
          if (
            bankData.data?.data?.checksDetails[0].uploaded_documents[i]
              .document_id == 45
          ) {
            setUrl(
              bankData.data?.data?.checksDetails[0].uploaded_documents[i]
                .preview_key
            );
          }
        }
      }
      if(bankData.data?.data?.verify_name){
        setIsDivVisible(true);
      }
      if (bankData.data?.data?.checksDetails[0].fields) {
        for (let i in bankData.data?.data?.checksDetails[0].fields) {
          setEditBankDetail((prevState) => ({
            ...prevState,
            [bankData.data?.data?.checksDetails[0].fields[i].label]:
              bankData.data?.data?.checksDetails[0].fields[i].field_value,
          }));
        }
      }
    }
  }, [bankData, storeData]);

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  useEffect(() => {
    if (
      typeof saveBankValue.data !== "undefined" &&
      saveBankValue.data !== null
    ) {
      if (saveBankValue.data.group.group_id == "profile_preview") {
        navigate(
          `/case-initiation/profile-preview/${saveBankValue.data.reference_number}`
        );
        dispatch(deleteSaveBankData());
      } else {
        navigate(
          `/case-initiation/check-detail/${saveBankValue.data.reference_number}/${saveBankValue.data.group.group_id}`
        );
        dispatch(deleteSaveBankData());
      }
    }
  }, [saveBankValue, storeData1]);

  const handleChange = async (file) => {
    let fil = file.name.lastIndexOf(".") + 1;
    let fileType = file.name.substring(fil);

    if (
      fileType !== "png" &&
      fileType !== "jpg" &&
      fileType !== "pdf" &&
      fileType !== "jpeg" &&
      fileType !== "PNG" &&
      fileType !== "JPG" &&
      fileType !== "PDF" &&
      fileType !== "JPEG"
    ) {
      alert("Wrong file format");
      return false;
    }

    if (file.size > 5242880) {
      alert("File cannot be larger than 5mb");
      return false;
    }
    setFileName1(file.name);
    setFileError(false);
    let record = {};
    record.mode = "check_documents";
    record.chkid = bankData.data?.data?.checksDetails[0].case_check_id;
    record.docid =
      bankData.data?.data?.checksDetails[0].required_documents[0].id;
    record.check_documents = [file];
    let dat = await dispatch(getUploadFile(record, file));
    setUrl(dat.data[0].preview_key);
  };

  const handleTrashClick = () => {
    setFileName1("");
    let record = {};
    record.mode = "check_documents";
    record.doc_ref = "all";
    record.doc_chk = bankData.data?.data?.checksDetails[0].case_check_id;
    record.doc_ids =
      bankData.data?.data?.checksDetails[0].required_documents[0].id;
    dispatch(removeFile(record));
  };

  const handleImageModal = (e, modalImage) => {
    e.preventDefault();
    e.stopPropagation();
    setImage(modalImage);
    setShowImageModal(!showImageModal);
  };

  const closePopup = () => {
    setImage("");
    setShowImageModal(false);
  };

  const handleContinue = () => {
    let record = {};
    const formData = getFormData();
    record.check_data = { ...formData };
    record.case_check_id = bankData.data.data.checksDetails[0].case_check_id;
    console.log(record);
    dispatch(saveBankData(record));
  };

  const handleInputChange = (e) => {
    console.log(e.target.value);

    // if (instantBank?.msg?.description == "Success`") {
    //   setDisableContinue(true);
    // }
    setDisableContinue(true);
    // dispatch(deleteInstantBankData());
    switch (e.target.name) {
      case "Name of the Account holder":
      case "Bank Name":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]:
            e.target.value === ""
              ? true
              : !validateAlphabetsAndSpace(e.target.value),
        }));
        break;
      case "Bank Account Number":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]:
            e.target.value === "" ? true : !containsOnlyNumbers(e.target.value),
        }));
        break;
      case "Bank Branch address":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]:
            e.target.value === ""
              ? true
              : !validateAlphabetsAndNumericWithSpace(e.target.value),
        }));
        break;
      case "IFSC Code of Branch":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]:
            e.target.value === ""
              ? true
              : !validateAlphabetsAndNumeric(e.target.value),
        }));
        break;
    }
    // console.log(validateAlphabetsAndNumeric(e.target.value));

    setEditBankDetail((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    console.log(editBankDetail);
  };

  const handleSave = (e) => {
    e.preventDefault();
    let hasError = false;
    for (let i in bankData.data?.data?.checksDetails[0].fields) {
      if (
        editBankDetail[bankData.data?.data?.checksDetails[0].fields[i].label] ==
          "" ||
        editBankDetail[
          bankData.data?.data?.checksDetails[0].fields[i].label
        ] === null
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [bankData.data?.data?.checksDetails[0].fields[i].label]: true,
        }));
      }
    }

    if (fileName1 == "") {
      hasError = true;
      setFileError(true);
    }
    for (var i in errorData) {
      if (errorData[i] == true) {
        hasError = true;
        break;
      }
    }
    if (hasError) {
      return;
    }
    let record = {};
    const formData = getFormData();
    record.check_data = { ...formData };
    record.case_check_id = bankData.data.data.checksDetails[0].case_check_id;
    console.log(record);

    dispatch(saveBankData(record));
  };

  const renderDragDropChildren = () => (
    <>
      <input type="file" id="myFile" className="mt-2" name="filename" />

      <div className="row uploadBox justify-content-around border rounded w-100 ml-3">
        <div className="col-2 align-self-center">
          <img src={UploadIcon} alt="UploadIcon" width="32px" height="32px" />
        </div>
        <div className="col-8 align-self-center">
          <div className="row uploadCardText1">
            Upload Cancelled Cheque<sup className="text-danger">*</sup>
          </div>
          <div className="row uploadCardText2">
            upload PNG, JPEG, JPG, PDF (max file size 5mb)
          </div>
        </div>
        <div className="col-1 align-self-center">
          <img
            src={RightArrowIcon}
            alt="RightArrowIcon"
            width="5px"
            height="10px"
          />
        </div>
      </div>
    </>
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    for (let i in bankData.data?.data?.checksDetails[0].fields) {
      if (
        editBankDetail[bankData.data?.data?.checksDetails[0].fields[i].label] ==
          "" ||
        editBankDetail[
          bankData.data?.data?.checksDetails[0].fields[i].label
        ] === null
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [bankData.data?.data?.checksDetails[0].fields[i].label]: true,
        }));
      }
    }
    for (var i in errorData) {
      if (errorData[i] == true) {
        hasError = true;
        break;
      }
    }
    if (hasError) {
      return;
    }
    let record = {};
    for (var i in bankData.data?.data?.checksDetails[0].fields) {
      if (
        bankData.data?.data?.checksDetails[0].fields[i].label ==
        "Bank Account Number"
      ) {
        record.bank_account_number =
          editBankDetail[bankData.data?.data?.checksDetails[0].fields[i].label];
      }
      if (
        bankData.data?.data?.checksDetails[0].fields[i].label ==
        "IFSC Code of Branch"
      ) {
        record.ifsc =
          editBankDetail[bankData.data?.data?.checksDetails[0].fields[i].label];
      }
    }
    record.case_id = bankData.data?.data?.candidates.initial_case_id;
    dispatch(getInstantBankData(record));
  };

  const getFormData = () => {
    const formData = {};
    let data = {};
    for (var i in bankData.data?.data?.checksDetails[0].fields) {
      formData[
        `${bankData.data?.data?.checksDetails[0].fields[i].ibridge_field_id}`
      ] = editBankDetail[bankData.data?.data?.checksDetails[0].fields[i].label];
    }
    formData.group = "bank_verify";
    data[bankData.data.data.checksDetails[0].case_check_id] = { ...formData };
    return data;
  };

  return (
    <>
      {/* <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>} */}
      
      <div className="p-3 form2 form-section">
        <div className="row">
          <div className="col-lg-9 col-md-12 col-sm-12">
            <div className="card-header p-0">
              <h2 className="fnt-smi-bld">Bank account verification</h2>
              <p className="text-muted">
                Please provide/upload required information
              </p>
            </div>
            <div className="card-body px-0">
              <h5 className="cardsubhead">
                Please enter following information
              </h5>
              <div className="row">
                {/* form */}
                <div className="col-12">
                  <div>
                    <form className="row w-100">
                      {bankDetail &&
                        Object.entries(bankDetail).map((fields, arr) => {
                          return (
                            <>
                              <div className="form-group col-lg-5 col-md-12 col-sm-12">
                                <div className="floating-label">
                               
                               
                                {fields[1].field_input_type == 1 ? (
                                  <input
                                    type="text"
                                    value={editBankDetail[fields[1]?.label]}
                                    className="form-control"
                                    id="inputAccNo"
                                    name={fields[1].label}
                                    onChange={handleInputChange}
                                    // placeholder={`Enter ${fields[1].label}`}
                                  />
                                ) : (
                                  ""
                                )}
                                {errorData[fields[1].label] === true ? (
                                  editBankDetail[fields[1].label] === "" ||
                                  editBankDetail[fields[1].label] === null ? (
                                    <p className="text-danger">
                                      This is a required field.
                                    </p>
                                  ) : (
                                    <p className="text-danger">
                                      Please provide valid input
                                    </p>
                                  )
                                ) : (
                                  <></>
                                )}
                                {/* <p className="text-danger">{formError.bankName}</p>  */}
                                <label
                                  className={`form-label ${editBankDetail[fields[1].label] ? "focused" : ""}`}
                                  htmlFor="inputAccNo"
                                >
                                  {fields[1].label}
                                  <sup className="text-danger">*</sup>
                                </label>
                              </div>
                              </div>
                            </>
                          );
                        })}
                    </form>
                    <div className="row my-3 d-flex justify-content-center align-items-start flex-column w-100">
                      <div className="form-group col-lg-6 col-md-12 col-sm-12 p-0">
                      {bankData.data?.data
                          ?.isInstantBankVerificationEnabled == 0 ? 
                          <>
                        <div
                          className="col-12"
                          style={{
                            color: "var(--gray-800, #1D2939)",
                            fontFamily: "Inter-Regular",
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "normal",
                          }}
                        >
                          Upload Document
                        </div>
                       
                            {fileName1 == "" ? (
                              <>
                                <FileUploader
                                  hoverTitle={"Choose Files"}
                                  classes={"file-upload w-100 border-0"}
                                  handleChange={handleChange}
                                  multiple={false}
                                  name="file"
                                  children={renderDragDropChildren()}
                                  onSizeError={(file) => {
                                    alert("file size larger than 5 mb");
                                  }}
                                  onClick={(e) => (e.target.value = null)}
                                />
                                {fileError ? (
                                  <p className="text-danger">
                                    This is a required field.
                                  </p>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    borderRadius: "4px",
                                    border:
                                      "1px solid var(--gray-300, #D0D5DD)",
                                    background: "var(--White, #FFF)",
                                  }}
                                  className="col-12 d-flex align-items-center justify-content-center bg-white uploadedDoc my-2 px-3"
                                >
                                  <img
                                    src={url}
                                    alt="UploadedDoc"
                                    style={{
                                      maxWidth: "35px",
                                      width: "100%",
                                      maxHeight: "50px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  <div className="d-flex align-items-center justify-content-between w-100 mx-3">
                                    <p
                                      className="text-truncate pt-3"
                                      style={{
                                        maxWidth: 200,
                                      }}
                                    >
                                      {fileName1}
                                    </p>
                                    <i
                                      className="fas fa-eye text-muted mr-3 cursor-pointer"
                                      onClick={(e) => handleImageModal(e, url)}
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      style={{
                                        maxWidth: "12px",
                                        width: "100%",
                                      }}
                                      title="View"
                                    ></i>
                                    <img
                                      src={Bin}
                                      onClick={() => handleTrashClick("1")}
                                      alt="Delete"
                                      style={{
                                        maxWidth: "12px",
                                        width: "100%",
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                         : (
                          ""
                        )}

                        {showImageModal && (
                          <ImagePopup
                            showModalBox={1}
                            title={"Uploaded file"}
                            description={"..."}
                            isAdd={true}
                            image={image}
                            closePopup={closePopup}
                          />
                        )}

                        {/* {showModal === 1 &&
        <CustomPopUp    
            showModalBox={showModal}
            closePopup={closeModal}
            record={record}
            title={fileName1}
            reRenderAgain={reRender}
        />
             
    } */}
                      </div>
                    </div>
                    {bankData.data?.data?.isInstantBankVerificationEnabled ==
                    1 ? (
                      <div
                        className="btn btn-primary ml-3 cursor-pointer"
                        onClick={handleSubmit}
                      >
                        Submit
                      </div>
                    ) : (
                      ""
                    )}

                    {isDivVisible && (
                      <div className="showDetail row ">
                        <table className="table tableDetail table-borderless table-hover">
                          <thead>
                            <tr>
                              <th scope="col" className="detailCol">
                                Details
                              </th>
                              <th className="detailCol"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th
                                scope="row"
                                className="detailRow"
                                style={{
                                  boxShadow:
                                    "rgba(0, 0, 0, 0.15) 0px 3px 3px 0px",
                                  width: "36%",
                                }}
                              >
                                Beneficiary Name
                              </th>
                              <td
                                className="detailRow"
                                style={{
                                  boxShadow:
                                    "rgba(0, 0, 0, 0.15) 0px 3px 3px 0px",
                                }}
                              >
                                {instantBank?.msg?.name || bankData.data?.data?.verify_name}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <button
                          type="submit"
                          className="btn btn-primary m-3 ml-0 mt-5"
                          disabled={disableContinue}
                          onClick={handleContinue}
                        >
                          Continue
                        </button>
                      </div>
                    )}

                    {bankData.data?.data?.isInstantBankVerificationEnabled ==
                    0 ? (
                      <div className="row">
                        {/* <button className="btn btn-outline-secondary">
                        Back
                      </button> */}
                        <button
                          type="submit"
                          className="btn btn-primary ml-3"
                          onClick={handleSave}
                        >
                          Continue
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                    {bankData?.data?.data?.showProfilePreview == 1 && (
                      <div className="row">
                        <div className="col-auto d-flex justify-content-between">
                          <button
                            className="btn btn-primary btn-lg btn-block mt-3"
                            onClick={(e) => handleSubmitForPreview(e)}
                          >
                            {clientId == 459831 ? "Preview" : "Submit for Preview"}
                          </button>
                        </div>
                        <div className="col-auto d-flex justify-content-between mt-4">
                          <small className="text-muted">
                            Please complete all the mandatory fields before
                            final submission
                          </small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* form */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BankVerification;
